import { TableCard } from '../../../../components'
import { UnidadesListHeader } from './components/header/UnidadesListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { UnidadesTable } from './table/UnidadesTable'

const UnidadesList = () => {
  return (
    <TableCard>
      <UnidadesListHeader />
      <UnidadesTable />
    </TableCard>
  )
}

export const UnidadesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <UnidadesList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
